import CloseIcon from "../../../assets/img/illustrations/close.svg";

const ImagePreview = ({ imgFile = "", closeButton = () => {} }) => {
  return (
    <div className="image-preview">
      <img
        onClick={closeButton}
        className="image-preview__close-button"
        src={CloseIcon}
      />
      <div onClick={closeButton} className="image-preview__img-container">
        <img className="image-preview__img" src={imgFile} />
      </div>
    </div>
  );
};

export default ImagePreview;
